'use client'

import usePartner from './use-partner'

import { ActivityIndicator, Alert } from '@/components'
import AccountDeletion, {
  EAccountDeletionState,
} from '@/components/pages/account-deletion/account-deletion'
import { useAppSelector } from '@/libs/hooks/use-app-selector'

type TPartnerProps = {
  partner_id: string
  signed: string
}

export default function Partner({ partner_id, signed }: Readonly<TPartnerProps>) {
  const { isPending, error, redirectToLogin, alert } = usePartner({
    partner_id,
    signed,
  })

  const { accountDeletedPir } = useAppSelector((state) => state.ui)

  if (accountDeletedPir) {
    return <AccountDeletion state={EAccountDeletionState.DELETED} />
  }

  return (
    <main className='flex flex-row'>
      <div className='mx-auto md:flex-grow'>
        <div className='relative mx-auto flex flex-col gap-4 px-5 py-4 md:w-10/12 md:py-6 lg:py-9 xl:py-12'>
          {isPending && (
            <div className='mx-auto' data-testid='activity-indicator'>
              <ActivityIndicator size='large' />
            </div>
          )}
          <Alert
            {...alert}
            buttonTitle={(error as any)?.error?.code === 'USER_EXIST' ? 'Login' : ''}
            onSubmit={() =>
              (error as any)?.error?.code === 'USER_EXIST' ? redirectToLogin() : null
            }
          />
        </div>
      </div>
    </main>
  )
}
